module.exports = __webpack_public_path__ + "img/map.3bc75826.png";